// src/index.ts
var MEMORY_CACHE = {};
var MStorage = class {
  constructor() {
    this.getItem = (name) => {
      return this.getItemByKeys([name]).then((res) => {
        return res[0];
      });
    };
    this.setItem = (name, value) => {
      return this.setItemByKeys([[name, value]]).then((res) => {
        return res[0];
      });
    };
    this.getItemByKeys = (keys) => {
      return this.openMStorage().then((storage) => {
        return keys.map((name) => {
          const { data } = JSON.parse(storage.getItem(name) || "{}");
          return data;
        });
      });
    };
    this.setItemByKeys = (pair) => {
      return this.openMStorage().then((storage) => {
        return pair.map(([name, value]) => {
          const dataValue = typeof value === "string" ? JSON.stringify({ data: value }) : JSON.stringify({ data: value });
          storage.setItem(name, dataValue);
          return value;
        });
      });
    };
    this.removeItem = (name) => {
      return this.openMStorage().then((storage) => {
        storage.removeItem(name);
      });
    };
    this.getKeys = () => {
      return this.openMStorage().then(() => {
        return Object.keys(MEMORY_CACHE);
      });
    };
    this.openMStorage = () => {
      return Promise.resolve({
        setItem(name, value) {
          MEMORY_CACHE[name] = `${value}`;
        },
        getItem(name) {
          return MEMORY_CACHE[name] || null;
        },
        removeItem(name) {
          delete MEMORY_CACHE[name];
        }
      });
    };
  }
};
MStorage.isSupport = () => {
  return true;
};
var src_default = MStorage;
export {
  src_default as default
};
